import React, {
	useCallback,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { ColDef } from "ag-grid-enterprise";
import api from "../../utils/axios";
import { useNavigate } from "react-router-dom";
import classes from "./index.module.css";
import {
	Button,
	DatePicker,
	Divider,
	Modal,
	Select,
	SelectProps,
	message,
} from "antd";
import dayjs, { Dayjs } from "dayjs";
import { ReactComponent as ExportIcon } from "../../assets/arrow-download-small.svg";
import { ReactComponent as RegisterIcon } from "../../assets/add-plus.svg";
import { ReactComponent as CodeIcon } from "../../assets/codeinput.svg";
import { ReactComponent as SearchIcon } from "../../assets/search-find.svg";
import DefaultInput from "../../components/form/DefaultInput";
import DefaultSelect from "../../components/form/DefaultSelect";
import PaginationTable from "../../components/Pagination";
import { toast } from "react-toastify";
import { thousandsFormatter, valueDateFormatter } from "../../utils/formatters";
import DefaultPhoneInput from "../../components/form/DefaultPhoneInput";
import FinanceStatistic from "../../components/FinanceStatistic";
import { fetchZones, getConfigurationValue } from "../../lib/OptionListApi";
import DefaultSwitch from "../../components/form/DefaultSwitch";
import {
	exportDataToCsv,
	moneyExportColumns,
} from "../../utils/exportDataToCsv";
import { dualMoneyColumns } from "../../utils/moneyColumns";
import useCurrencies from "../../hooks/useCurrencies";
import { CURRENCY_EUR } from "../../api/currency/types";
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import DefaultPasswordInput from "../../components/form/DefaultPasswordInput";
import { getUserRoleFromToken } from "../../utils/Auth";
import { usernamePasswordValidate } from "../../types/UsernamePasswordValidate";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import L, { Icon, LatLngExpression, LatLngTuple } from "leaflet";
import Buttons from "../../components/form/Buttons";
import { userRoles } from "../../types/enums";
import useLang from "../../hooks/useLang";
import { useMediaQuery } from "@mui/material";
import { hasAccess } from "../../lib/MenuValidation";
import PlaceAutocomplete from "../../components/GoogleMaps/PlaceAutocomplete";
import { CONFIG } from "../../config";
import AddressSelect from "../../components/form/AddressSelect";

interface RowData {
	id: number;
	firstName: string;
	businessName: string;
	businessNr: string;
	processing: string;
	delivered: string;
	refused: string;
	/**
	 * What the seller is still owed. On PostmanAL this is the **local-currency half only**,
	 * bucketed on the currency each order was **registered** in — the seller is credited in the
	 * currency they chose, not the one the buyer happened to pay in.
	 */
	balance: number;
	/** Everything ever settled to this seller. Same split as `balance`. */
	cashFlow: number;
	/**
	 * EUR halves of the two above. Absent off PostmanAL, where the API never returns them.
	 * **Never add them to their local twins** — two independent accounts, not two halves of one.
	 */
	balanceEur?: number;
	cashFlowEur?: number;
	createdAt: string | null;
}

const { Option } = Select;
const { RangePicker } = DatePicker;
const NOMINATIM_BASE_URL = "https://nominatim.openstreetmap.org/search?";

const Client = () => {
	const navigate = useNavigate();
	let defaultExcelExportSettings = {};
	const defaultColDef = useMemo(
		() => ({
			sortable: true,
			filter: true,
			wrapHeaderText: true,
			resizable: true,
			filterParams: { excelMode: "windows" },
			autoSizeAllColumns: true,
		}),
		[]
	);
	let grid = useRef(null);
	const [open, setOpen] = useState<boolean>(false);
	const [tableData, setTableData] = useState([]);
	const [tableColumns, setTableColumns] = useState<ColDef[]>();
	const [firstLastName, setFirstLastName] = useState<string>("");
	const [email, setEmail] = useState<string>("");
	const [username, setUsername] = useState<string>("");
	const [password, setPassword] = useState<string>("");
	const [confirmPassword, setConfirmPassword] = useState<string>("");
	const [phone, setPhone] = useState<string>("");
	const [businessNumber, setBusinessNumber] = useState<string>("");
	const [businessName, setBusinessName] = useState<string>("");
	const [businessPhoneNumber, setBusinessPhoneNumber] = useState<string>("");
	const [address, setAddress] = useState<string>("");
	const [identificationNumber, setIdentificationNumber] = useState<
		string | undefined
	>();
	const [country, setCountry] = useState<string | undefined>();
	const [city, setCity] = useState<string | undefined>();
	const [countryDropDown, setCountryDropDown] = useState<any>([]);
	const [cityDropDown, setCityDropDown] = useState<any>([]);
	const [cities, setCities] = useState<any>([]);
	const [countryLabel, setCountryLabel] = useState<string>("xk");
	const [cityLabel, setCityLabel] = useState<string | undefined>("");
	const [apiLatitude, setApiLatitude] = useState<number | null>();
	const [apiLongitude, setApiLongitude] = useState<number | null>();
	const [sectionId, setSectionId] = useState<number>();
	const [finalAddress, setFinalAddress] = useState<string>("");

	const [cash, setCash] = useState<boolean>(true);
	const [bank, setBank] = useState<boolean>(false);
	const [vat, setVat] = useState<boolean>(false);
	const [code, setCode] = useState<number>();
	const [search, setSearch] = useState<string>("");
	const [fromDate, setFromDate] = useState<Dayjs | null>(null);
	const [toDate, setToDate] = useState<Dayjs | null>(null);
	const [zones, setZones] = useState<any>([]);
	const [modalCountry, setModalCountry] = useState<string | undefined>();
	const [modalCity, setModalCity] = useState<string | undefined>();
	const [isAdmin, setIsAdmin] = useState<boolean>();

	const [selectedCountry, setSelectedCountry] = useState();
	const [countryError, setCountryError] = useState<boolean>(false);
	const [cityError, setCityError] = useState<boolean>(false);
	const [selectedCity, setSelectedCity] = useState<string | undefined>();
	const [addressError, setAddressError] = useState<boolean>(false);
	const [adressPosition, setAddressPosition] = useState<any>(null);
	const [latitude, setLatitude] = useState<number | null>(null);
	const [longitude, setLongitude] = useState<number | null>(null);
	const [mapCenter, setMapCenter] = useState<LatLngTuple | null>([
		42.6026, 20.903,
	]);

	const [position, setPosition] = useState<any>(null);
	const [mapInitialized, setMapInitialized] = useState<boolean>(false);

	const [personalIdLength, setPersonalIdLength] = useState<number>();
	const [allSections, setAllSections] = useState<any>([]);

	const hasAccessToClientDetails = hasAccess("CLIENT_DETAILS_ACCESS");

	const markerRef = useRef(null);

	const nameAndSurnameGetter = (params: any) => {
		const text = params.data.firstName + " " + params.data.lastName;
		return text;
	};
	const { strings } = useLang("client");
	const { dualCurrencyEnabled, defaultCurrencyId } = useCurrencies();
	const setCountriesAndCities = async () => {
		const zones = await fetchZones();
		if (zones) {
			const countries = zones
				.filter((item: any) => item.levelId === 1)
				.map((item: any) => ({
					value: item.id,
					label: item.description,
				}));
			setCountryDropDown(countries);
			const filteredCities = zones
				.filter((item: any) => item.levelId === 2)
				.map((item: any) => ({
					value: item.id,
					label: item.description,
				}));
			setCityDropDown(filteredCities);
			const cities = zones?.filter((item: any) => item.levelId === 2);
			setCities(cities);
			const sections = zones?.filter((item: any) => item.levelId === 3);
			setAllSections(sections);
		}
	};

	const fetchGeoData = useCallback(async (latitude: any, longitude: any) => {
		try {
			const response = await api.get("External/get-geo-data", {
				params: {
					lng: longitude,
					lat: latitude,
					category: CONFIG?.zoneMbledhs ?? "",
				},
			});
			if (response.status === 200) {
				const result = response?.data;
				const section = Number(result.geofences[0]?.name);
				setSectionId(section);
				setFinalAddress(result.result);
			}
		} catch (error) {
			console.log(error);
		}
	}, []);

	const getTableData = async () => {
		try {
			const response = await api.get("User/clients");
			if (response.data) {
				setTableData(response.data);
			}
		} catch (error: any) {
			console.log(error);
		}
	};
	const getIdentificationNumberAllowedLength = async () => {
		try {
			setPersonalIdLength(parseInt(await getConfigurationValue(3)));
		} catch (error: any) {
			console.log(error);
		}
	};

	const isSmallScreen = useMediaQuery("(max-width: 994px)");

	useEffect(() => {
		const userRoleId = getUserRoleFromToken();
		userRoleId === userRoles.ADMIN ? setIsAdmin(true) : setIsAdmin(false);
		getTableData();
		getIdentificationNumberAllowedLength();
		setCountriesAndCities();
	}, [setTableColumns, strings]);

	// Column building was split out of the effect above, which is left with exactly the dependency
	// list it always had.
	//
	// The columns have to depend on `dualCurrencyEnabled` / `defaultCurrencyId`, which resolve one
	// render after first paint — a grid built without them keeps its single-currency layout forever
	// (W-D17). The three fetches must not: adding those flags to their list would reload the whole
	// client list again on every cold page load.
	useEffect(() => {
		setTableColumns([
			{
				headerCheckboxSelection: true,
				checkboxSelection: true,
				width: 60,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "id",
				headerName: strings?.code,
				width: 80,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "uniqueSellerIdentifier",
				headerName: strings?.uniqueCode,
				width: 80,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "firstName",
				valueGetter: nameAndSurnameGetter,
				headerName: strings?.firstLastName,
				cellStyle: (params: any) => ({
					fontSize: "14px",
					fontWeight: "400",
					lineHeight: "18px",
					color: "#4F16C2",
					fontFamily: "Inter",
					textDecoration: "underline",
				}),
				width: 160,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "username",
				headerName: "Username",
				width: 140,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "phone",
				headerName: strings?.phone,

				suppressSizeToFit: isSmallScreen,
				// width: 130,
			},
			{
				field: "businessName",
				headerName: strings?.businessName,
				width: 150,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "businessNr",
				headerName: strings?.businessNumber,
				width: 140,
				suppressSizeToFit: isSmallScreen,
			},

			{
				field: "processing",
				headerName: strings?.processing,
				width: 140,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "delivered",
				headerName: strings?.delivered,
				width: 140,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "refused",
				headerName: strings?.refused,
				width: 110,
				suppressSizeToFit: isSmallScreen,
			},
			// The seller's two money figures. Two columns of equal weight each on PostmanAL, one
			// plain column each everywhere else — the gate is inside `dualMoneyColumns` (W-D17),
			// so there is no feature check here and no empty "EUR" column can reach Kosovo.
			//
			// Both bucket on the currency the order was **registered** in, which is the seller's
			// side of the ledger (API D13): they are owed what they agreed, and whatever the buyer
			// handed the driver at the door is exchange exposure the company absorbs. That is the
			// opposite rule from the drivers list one screen over, where the two columns are the
			// physical cash the driver is holding and the API converts per order to get there.
			// Nothing is converted here, so each column is a true LEK or EUR total.
			//
			// These are the same four figures the client-DETAILS page has shown since 2026-08-14
			// (`SelectClientFinance_sp`), which is what the list disagreed with until now.
			...dualMoneyColumns({
				field: "balance",
				headerName: strings?.balance,
				dualCurrencyEnabled,
				defaultCurrencyId,
				width: 110,
				suppressSizeToFit: isSmallScreen,
			}),
			...dualMoneyColumns({
				field: "cashFlow",
				headerName: strings?.cashFlow,
				dualCurrencyEnabled,
				defaultCurrencyId,
				width: 140,
				suppressSizeToFit: isSmallScreen,
			}),
			{
				field: "createdAt",
				headerName: strings?.createdAt,
				valueFormatter: (params) => valueDateFormatter(params.value),
				width: 160,
				suppressSizeToFit: isSmallScreen,
			},
		]);
	}, [dualCurrencyEnabled, defaultCurrencyId, setTableColumns, strings]);

	const getValidCoordinates = (
		lat: number | null,
		lng: number | null
	): LatLngExpression | null => {
		if (lat !== null && lng !== null) {
			return [lat, lng];
		}
		return null;
	};

	const onCellClicked = async (params: any) => {
		const colId = params.column.colId;
		switch (colId) {
			case "businessName":
				await onClientIdClicked(params?.data);
				break;
			case "firstName":
				await onClientIdClicked(params?.data);
				break;
		}
	};
	const onClientIdClicked = (data: any) => {
		const clientId = data?.id?.toString();
		if (hasAccessToClientDetails) {
			const url = `/client-details?id=${clientId}`;
			window.open(url, "_blank");
		} else {
			toast.error("Error! Nuk keni qasje ne detaje te klienteve");
			return;
		}
	};

	const openModalForNewClient = useCallback(async () => {
		setCountriesAndCities();
		if (mapCenter === null) {
			setMapCenter([42.6026, 20.903]);
			setLatitude(42.6026);
			setLongitude(20.903);
			const position = getValidCoordinates(latitude, longitude);
			setPosition(position);
		}
		setOpen(true);
	}, [latitude, longitude, mapCenter]);

	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(20);
	const totalItems = tableData.length;

	const handlePageChange = (page: any) => {
		setCurrentPage(page);
	};

	const handlePageSizeChange = (current: number, size: number) => {
		setPageSize(size);
		setCurrentPage(1);
	};

	const filteredData = useMemo(() => {
		const fromDateObj = fromDate ? fromDate.startOf("day") : null;
		const toDateObj = toDate ? toDate.endOf("day") : null;
		return tableData.filter((item: any) => {
			const itemDate = item.createdAt ? dayjs(item.createdAt) : null;
			return (
				(!fromDateObj ||
					(itemDate && !itemDate.isBefore(fromDateObj))) &&
				(!toDateObj || (itemDate && !itemDate.isAfter(toDateObj))) &&
				(!code ||
					item.id.toString().includes(code) ||
					(item.uniqueSellerIdentifier &&
						item.uniqueSellerIdentifier
							?.toLowerCase()
							.includes(code))) &&
				(!search ||
					(item.firstName &&
						item.firstName
							?.toLowerCase()
							.includes(search?.toLowerCase())) ||
					(item.lastName &&
						item.lastName
							?.toLowerCase()
							.includes(search?.toLowerCase())) ||
					(item.username &&
						item.username
							?.toLowerCase()
							.includes(search?.toLowerCase())) ||
					(item.businessName &&
						item.businessName
							?.toLowerCase()
							.includes(search?.toLowerCase()))) &&
				(!city || item.cityId === city) &&
				(!country || item.countryId === country)
			);
		});
	}, [city, code, country, search, tableData, fromDate, toDate]);

	const paginatedClients = useMemo(() => {
		const dataToPaginate = filteredData;
		const startIndex = (currentPage - 1) * pageSize;
		const endIndex = startIndex + pageSize;
		return dataToPaginate.slice(startIndex, endIndex);
	}, [currentPage, filteredData, pageSize]);

	const startIndex = (currentPage - 1) * pageSize + 1;
	const endIndex = startIndex + Math.min(pageSize, totalItems - startIndex);

	const onCountrySelect = (e: any) => {
		setCity("");
		const filteredCities = cities
			.filter((item: any) => item.parentId === e)
			.map((item: any) => ({
				value: item.id,
				label: item.description,
			}));
		setCityDropDown(filteredCities);
		setCountry(e);
		setCurrentPage(1);
	};
	const onCitySelect = (e: any) => {
		setCity(e);
		setCurrentPage(1);
	};

	const validateInsertedData = (data: any) => {
		const {
			firstName,
			lastName,
			phone,
			address,
			username,
			password,
			identificationNumber,
			sectionId,
		} = data;
		if (!firstName) {
			toast.error("Emri është i detyrueshëm!");
			return false;
		}
		if (!lastName) {
			toast.error("Mbiemri është i detyrueshëm!");
			return false;
		}
		if (!phone) {
			toast.error("Numri i telefonit është i detyrueshëm");
			return false;
		}
		if (!address) {
			toast.error("Adresa është e detyrueshme");
			return false;
		}
		if (!username) {
			toast.error("Username është i detyrueshëm");
			return false;
		}
		if (!password) {
			toast.error("Password është i detyrueshëm");
			return false;
		}
		if (!identificationNumber) {
			toast.error("Nr.Leternjoftimit është i detyrueshëm.");
			return false;
		}
		if (identificationNumber?.length !== personalIdLength) {
			toast.error(
				"Numri i leternjoftimit duhet të jetë i gjatë 10 karaktere."
			);
			return false;
		}
		if (!sectionId) {
			toast.error("Zona është e detyrueshme");
			return false;
		}

		return true;
	};

	const onBtExport = useCallback(() => {
		if (grid) {
			(grid.current as any).api.exportDataAsExcel();
		}
	}, []);

	const resetInputFields = () => {
		setFirstLastName("");
		setEmail("");
		setUsername("");
		setPassword("");
		setConfirmPassword("");
		setPhone("");
		setBusinessNumber("");
		setBusinessName("");
		setAddress("");
		setLatitude(42.6026);
		setLongitude(20.903);
		setPosition([42.6026, 20.903]);
		setMapCenter([42.6026, 20.903]);
		setIdentificationNumber("");
	};

	const onModalCountrySelect = (e: any) => {
		const filteredCities = cities
			.filter((item: any) => item.parentId === e)
			.map((item: any) => ({
				value: item.id,
				label: item.description,
			}));
		setCityDropDown(filteredCities);
		setModalCountry(e);
		setAddress("");
		setSectionId(0);
		if (e === 1) {
			setMapCenter([42.6026, 20.903]);
			setPosition(null);
			setCountryLabel("xk");
		} else if (e === 2) {
			setMapCenter([41.1533, 20.1683]);
			setPosition(null);
			setCountryLabel("al");
		} else if (e === 3) {
			setMapCenter([41.6086, 21.7453]);
			setPosition(null);
			setCountryLabel("mk");
		}
		setModalCity("");
	};

	const onModalCitySelect = (value: any) => {
		if (value?.value) {
			const id = value.value;
			setModalCity(id);
			setCityLabel(value?.label);
			setAddress("");
			setSectionId(0);
		} else {
			setModalCity("");
			setCityLabel("");
			setAddress("");
			setSectionId(0);
		}
	};

	const [data, setData] = useState<SelectProps["options"]>([]);

	const [addressTypingTimeout, setAddressTypingTimeout] = useState<any>(null);

	useEffect(() => {
		return () => {
			if (addressTypingTimeout) {
				clearTimeout(addressTypingTimeout);
			}
		};
	}, [addressTypingTimeout]);

	const handleSearch = (address: any) => {
		if (!modalCountry || !modalCity) {
			toast.error("Ju lutem zgjedhni shtetin dhe qytetin");
			setAddress("");
			return;
		}
		if (addressTypingTimeout) {
			clearTimeout(addressTypingTimeout);
		}

		setAddressTypingTimeout(
			setTimeout(() => {
				fetchAddresesSearch(
					address +
						" ," +
						(cityLabel && cityLabel?.length > 0 ? cityLabel : "")
				);
			}, 400)
		);
	};

	const fetchAddresesSearch = (address: any) => {
		const params = {
			q: address || "",
			limit: "5",
			lang: "en",
		};
		const queryString = new URLSearchParams(params).toString();
		const requestOptions: RequestInit = {
			method: "GET",
			redirect: "follow",
		};
		fetch(`https://photon.komoot.io/api/?${queryString}`, requestOptions)
			.then((response) => response.json())
			.then((result) => {
				const formattedData = result.features.map((feature: any) => ({
					value: feature.properties.osm_id,
					label: feature.properties.name,
					lat: feature.geometry.coordinates[1],
					lon: feature.geometry.coordinates[0],
				}));

				setData(formattedData);
			})
			.catch((err) => console.log("err: ", err));
	};

	const handleChange = (address: any) => {
		const selectedLocation = address;
		if (selectedLocation) {
			const lat = selectedLocation.lat;
			const lng = selectedLocation.lng;
			setAddressPosition([lat, lng]);
			setPosition([lat, lng]);
			setApiLatitude(lat);
			setApiLongitude(lng);
			fetchGeoData(lat, lng);
			setAddress(selectedLocation.label ?? "");
		}
	};

	const validateUsernameAndEmail = async () => {
		try {
			const response = await api.get("User/validate-username-email", {
				params: { username: username, email: email ? email : null },
			});
			if (response.status === 200) {
				const result = response.data;
				if (result.message === "Valid") {
					return true;
				} else {
					toast.error(`${result.message}`);
					return false;
				}
			}
		} catch (error) {
			console.log(error);
		}
	};

	const registerNewClient = async () => {
		const fullNameArray = firstLastName.split(" ");
		const firstName = fullNameArray[0] || "";
		const lastName = fullNameArray.slice(1).join(" ");

		const validation = usernamePasswordValidate(username, password);

		if (!validation.valid) {
			toast.error(validation.message);
			return;
		}
		const existingSection = allSections?.some(
			(item: any) => sectionId !== null && item.id === sectionId
		);

		if (!existingSection) {
			toast.error(
				"Kjo Zone nuk eshte e regjistruar! Ju lutem kontaktoni Postman"
			);
			return;
		}
		const isUnique = await validateUsernameAndEmail();
		if (!isUnique) {
			return false;
		}

		const data = {
			firstName: firstName,
			lastName: lastName,
			phone: phone,
			address: address,
			username: username,
			email: email,
			password: password,
			userRoleId: userRoles.CLIENT,
			identificationNumber: identificationNumber,
			sectionId: sectionId,
			longitude: apiLongitude?.toString(),
			latitude: apiLatitude?.toString(),
			packagePriceIncudesTaxes: vat,
			bankPackageTransportPayment: bank,
			cashPackageTransportPayment: cash,
			businessName: businessName,
			businessNumber: businessNumber,
			businessNr: businessPhoneNumber,
		};
		if (validateInsertedData(data)) {
			try {
				const response = await api.post("User/register", data);
				if (response.status === 200) {
					await getTableData();
					resetInputFields();
					toast.success("Klienti u regjistrua me sukses!");
					setOpen(false);
					return;
				} else {
					toast.error(
						"Një gabim ndodhi gjatë krijimit. Ju lutemi provoni përsëri më vonë"
					);
				}
			} catch (error: any) {
				console.error(error.response.data);
			}
		} else {
			return;
		}
	};

	/**
	 * The sheet behind **Options → Eksporto te dhenat**.
	 *
	 * Both money figures go through `moneyExportColumns`, so each amount is a **number** Excel can
	 * sum and the currency it is in gets a column of its own (W-D31). Off PostmanAL each pair
	 * collapses to the one column the sheet has always had, reading the field exactly as it did
	 * before — which is why the row builder below still formats those two there and not here.
	 *
	 * The EUR halves are appended **only** where dual currency is on. They have never been on this
	 * sheet, and Kosovo and Macedonia are not supposed to see any change from this work.
	 *
	 * Headers are read off the grid, which already names these columns `… LEK` / `… EUR`.
	 */
	const selectedColumnIds = [
		"id",
		"firstName",
		"businessName",
		"businessNr",
		"processing",
		"delivered",
		"refused",
		...moneyExportColumns({
			colId: "balance",
			currencyHeaderName: `${strings?.currencyColumn} - ${strings?.balance}`,
			currency: defaultCurrencyId,
			dualCurrencyEnabled,
		}),
		...(dualCurrencyEnabled
			? moneyExportColumns({
					colId: "balanceEur",
					currencyHeaderName: `${strings?.currencyColumn} - ${strings?.balance}`,
					currency: CURRENCY_EUR,
					dualCurrencyEnabled,
			  })
			: []),
		...moneyExportColumns({
			colId: "cashFlow",
			currencyHeaderName: `${strings?.currencyColumn} - ${strings?.cashFlow}`,
			currency: defaultCurrencyId,
			dualCurrencyEnabled,
		}),
		...(dualCurrencyEnabled
			? moneyExportColumns({
					colId: "cashFlowEur",
					currencyHeaderName: `${strings?.currencyColumn} - ${strings?.cashFlow}`,
					currency: CURRENCY_EUR,
					dualCurrencyEnabled,
			  })
			: []),
		"createdAt",
	];

	const onExportSelectedId = () => {
		const dataToExport = filteredData.map((item: any) => {
			const row: any = {
				...item,
				firstName: `${item.firstName} ${item.lastName}`,
				createdAt: valueDateFormatter(item.createdAt),
			};

			// On PostmanAL the two money figures have to reach `moneyExportColumns` as raw
			// numbers: it writes a **numeric** cell, and a "45,000.00 L" string parses as NaN and
			// exports blank. Everywhere else each pair collapses back to the single column this
			// sheet has always had, so the formatting stays exactly where it was and Kosovo and
			// Macedonia see no difference at all.
			if (!dualCurrencyEnabled) {
				row.balance = thousandsFormatter(item.balance);
				row.cashFlow = thousandsFormatter(item.cashFlow);
			}

			return row;
		});
		exportDataToCsv(grid, selectedColumnIds, dataToExport);
	};

	const onFirstDataRendered = useCallback((params: any) => {
		(grid.current as any).api.sizeColumnsToFit();
	}, []);

	const [error, setError] = useState<boolean>(false);

	const handleConfirmPasswordChange = (e: any) => {
		setConfirmPassword(e.target.value);
		if (password === e.target.value) {
			setError(false);
		}
	};

	const handleBlur = useCallback(() => {
		if (password !== confirmPassword) {
			message.error("Fjalëkalimet nuk përputhen.");
			setError(true);
		} else {
			setError(false);
		}
	}, [confirmPassword, password]);

	const eventHandlers = useMemo(
		() => ({
			dragend() {
				const marker = markerRef.current;
				if (marker != null) {
					const latLng = marker["_latlng"];
					setPosition(latLng);
					setApiLatitude(latLng["lat"]);
					setApiLongitude(latLng["lng"]);
					fetchGeoData(latLng["lat"], latLng["lng"]);
				}
			},
		}),
		[]
	);

	const customIcon = new Icon({
		iconUrl: require("../../assets/pin.png"),
		iconSize: [38, 38],
	});

	const ResetCenterView = (props: any) => {
		const { selectedPosition } = props;
		const { addressPosition } = props;
		const map = useMap();
		useEffect(() => {
			if (selectedPosition === 1) {
				map.setView(L.latLng(42.6026, 20.903), map.getZoom(), {
					animate: true,
				});
			} else if (selectedPosition === 2) {
				map.setView(L.latLng(41.1533, 20.1683), map.getZoom(), {
					animate: true,
				});
			} else if (selectedPosition === 3) {
				map.setView(L.latLng(41.6086, 21.7453), map.getZoom(), {
					animate: true,
				});
			}
			if (addressPosition) {
				map.setView(L.latLng(addressPosition), 15, {
					animate: true,
				});
			}
		}, [addressPosition, map, selectedPosition]);

		return null;
	};

	useEffect(() => {
		if (open) {
			const timer = setTimeout(() => {
				setMapInitialized(true);
			}, 300);

			return () => clearTimeout(timer);
		} else {
			setMapInitialized(false);
		}
	}, [open]);

	const changeSwitch = () => {
		setCash((prevState) => !prevState);
		setBank((prevState) => !prevState);
	};
	return (
		<>
			<div className={classes.mainContainer}>
				{/* <FinanceStatistic /> */}

				<div className={classes.heroContainer}>
					<div className={classes.firstContainer}>
						<h1 className={classes.title}>
							{strings?.mainTitle}{" "}
							<span className={classes.clientsCount}>
								{/* {strings?.clientsCount} */}
							</span>
						</h1>
						<div className={classes.buttons}>
							<Button
								className={classes.button}
								onClick={onExportSelectedId}
							>
								<ExportIcon />
								{strings?.exportDataButton}
							</Button>
							<Button
								className={classes.button}
								onClick={openModalForNewClient}
							>
								<RegisterIcon />
								{strings?.registerNewClientButton}
							</Button>
						</div>
					</div>
					<div className={classes.inputs}>
						<DefaultInput
							label={strings?.searchCodeLabel}
							className={classes.input}
							prefix={<CodeIcon />}
							placeholder={strings?.searchCodePlaceholder}
							value={code}
							onChange={(e) => {
								setCurrentPage(1);
								setCode(e.target.value);
							}}
						/>
						<DefaultInput
							label={strings?.searchBusinessLabel}
							className={classes.input}
							placeholder={strings?.searchBusinessPlaceholder}
							prefix={<SearchIcon />}
							value={search}
							onChange={(e) => {
								setCurrentPage(1);
								setSearch(e.target.value);
							}}
						/>
						<DefaultSelect
							label={strings?.countrySelectLabel}
							flexDirection="col"
							alignCenter="start"
							className={classes.input}
							placeholder={strings?.countrySelectPlaceholder}
							options={countryDropDown}
							value={country}
							onChange={onCountrySelect}
							allowClear
						/>
						<DefaultSelect
							label={strings?.citySelectLabel}
							flexDirection="col"
							alignCenter="start"
							className={classes.input}
							placeholder={strings?.citySelectPlaceholder}
							options={cityDropDown}
							value={city}
							onChange={onCitySelect}
							allowClear
						/>
						<div className="flex flex-col">
							<p>{strings?.createdAtRangeLabel}</p>
							<RangePicker
								size="large"
								className={classes.rangePicker}
								allowClear
								allowEmpty={[true, true]}
								value={[fromDate, toDate]}
								placeholder={[
									strings?.createdFromPlaceholder,
									strings?.createdToPlaceholder,
								]}
								format="DD/MM/YYYY"
								disabledDate={(current) =>
									current && current.isAfter(dayjs(), "day")
								}
								presets={[
									{
										label: strings?.presetToday,
										value: [dayjs(), dayjs()],
									},
									{
										label: strings?.presetLast7Days,
										value: [
											dayjs().subtract(6, "day"),
											dayjs(),
										],
									},
									{
										label: strings?.presetLast30Days,
										value: [
											dayjs().subtract(29, "day"),
											dayjs(),
										],
									},
									{
										label: strings?.presetThisMonth,
										value: [
											dayjs().startOf("month"),
											dayjs(),
										],
									},
								]}
								onChange={(dates) => {
									setCurrentPage(1);
									setFromDate(dates?.[0] ?? null);
									setToDate(dates?.[1] ?? null);
								}}
							/>
						</div>
					</div>
					<div className={classes.pagination}>
						<PaginationTable
							current={currentPage}
							pageSize={pageSize}
							total={totalItems}
							startOrderIndex={startIndex}
							endOrderIndex={endIndex}
							onChange={handlePageChange}
							onShowSizeChange={handlePageSizeChange}
						/>
					</div>
					<div
						className="ag-theme-alpine"
						style={{
							height: 400,
							width: "100%",
						}}
					>
						<AgGridReact
							// rowData={filteredData}
							rowData={paginatedClients}
							columnDefs={tableColumns}
							defaultColDef={defaultColDef}
							undoRedoCellEditing={true}
							undoRedoCellEditingLimit={20}
							suppressCopyRowsToClipboard={true}
							defaultExcelExportParams={
								defaultExcelExportSettings
							}
							rowSelection="multiple"
							ref={grid}
							enableRangeSelection={true}
							cacheQuickFilter={true}
							onCellClicked={onCellClicked}
							onFirstDataRendered={onFirstDataRendered}
						/>
					</div>
				</div>
			</div>
			<Modal
				open={open}
				title={strings?.registerNewClientModalTitle}
				onCancel={() => {
					setOpen(false);
					resetInputFields();
				}}
				width={1300}
				footer={(_, { OkBtn, CancelBtn }) => (
					<>
						<div className={classes.createAccountDiv}>
							<Buttons
								button1Text={strings?.closeButton}
								button2Text={strings?.createAccountButton}
								onButton2Click={registerNewClient}
								onButton1Click={() => {
									setOpen(false);
									resetInputFields();
								}}
							/>
						</div>
					</>
				)}
			>
				<Divider />
				<div className={classes.modalContainer}>
					<div className={classes.modalInputsContainer}>
						<div className={classes.firstModalInputs}>
							<DefaultInput
								label={strings?.fullNameLabel}
								placeholder={strings?.fullNamePlaceholder}
								value={firstLastName}
								onChange={(e) =>
									setFirstLastName(e.target.value)
								}
								className={classes.registerInput}
							/>
							<DefaultPhoneInput
								label={strings?.phoneNumberLabel}
								placeholder={strings?.phoneNumberPlaceholder}
								initialPhoneNumber={phone}
								onPhoneNumberChange={(e) => setPhone(e)}
								className={classes.registerInputPhone}
								//className={classes.mobileRegisterInput}
							/>
							<DefaultInput
								className={classes.registerInput}
								label={strings?.identificationNumberLabel}
								value={identificationNumber}
								onChange={(e) =>
									setIdentificationNumber(e.target.value)
								}
								placeholder={
									strings?.identificationNumberPlaceholder
								}
							/>
							<DefaultInput
								className={classes.registerInput}
								label={strings?.usernameLabel}
								placeholder={strings?.usernamePlaceholder}
								value={username}
								onChange={(e) => setUsername(e.target.value)}
							/>
							<DefaultInput
								className={classes.registerInput}
								label={strings?.emailLabel}
								placeholder={strings?.emailPlaceholder}
								value={email}
								onChange={(e) => setEmail(e.target.value)}
							/>
							<DefaultPasswordInput
								className={classes.registerInput}
								label={strings?.passwordLabel}
								value={password}
								placeholder={strings?.passwordPlaceholder}
								onChange={(e) => setPassword(e.target.value)}
								onBlur={handleBlur}
								allowClear={true}
							/>
							<DefaultInput
								label={strings?.confirmPasswordLabel}
								className={classes.registerInput}
								value={confirmPassword}
								onChange={handleConfirmPasswordChange}
								onBlur={handleBlur}
								placeholder={
									strings?.confirmPasswordPlaceholder
								}
								status={error ? "error" : ""}
								type="password"
								suffix={
									error ? (
										<CloseCircleTwoTone twoToneColor="#ff4d4f" />
									) : (
										<CheckCircleTwoTone twoToneColor="#52c41a" />
									)
								}
								allowClear={true}
							/>
							<DefaultSelect
								className={classes.registerInput}
								onChange={onModalCountrySelect}
								value={modalCountry}
								placeholder={
									strings?.countrySelectModalPlaceholder
								}
								label={strings?.countrySelectModalLabel}
								flexDirection="col"
								alignCenter="start"
								options={countryDropDown}
								allowClear
								status={countryError ? "error" : ""}
							/>
						</div>
						<div className={classes.secondModalInputs}>
							<DefaultSelect
								className={classes.registerInput}
								placeholder={
									strings?.citySelectModalPlaceholder
								}
								value={modalCity}
								onChange={onModalCitySelect}
								label={strings?.citySelectModalLabel}
								flexDirection="col"
								alignCenter="start"
								options={cityDropDown}
								allowClear
								labelInValue={true}
								status={cityError ? "error" : ""}
							/>
							<div className="flex flex-col items-start gap-1">
								<label className="w-42 -mb-1">
									{strings?.addressLabel}
								</label>

								<AddressSelect
									onAddressChange={handleChange}
									country={countryLabel}
									selectedAddress={address}
									city={modalCity}
								/>
							</div>

							<DefaultInput
								label={strings?.businessNameLabel}
								placeholder={strings?.businessNamePlaceholder}
								value={businessName}
								onChange={(e) =>
									setBusinessName(e.target.value)
								}
								className={classes.registerInput}
							/>
							<DefaultInput
								label={strings?.businessNumber}
								placeholder={strings?.businessNumber}
								value={businessNumber}
								onChange={(e) =>
									setBusinessNumber(e.target.value)
								}
								className={classes.registerInput}
							/>
							<DefaultPhoneInput
								label={strings?.businessPhoneNumberLabel}
								placeholder={
									strings?.businessPhoneNumberPlaceholder
								}
								initialPhoneNumber={businessPhoneNumber}
								onPhoneNumberChange={(v) =>
									setBusinessPhoneNumber(v)
								}
								className={classes.registerInputPhone}
							/>
							<div className={classes.switchContainer}>
								<p>{strings?.postalServicePaymentLabel}</p>
								<div className={classes.switchDiv}>
									<DefaultSwitch
										label={strings?.cashPaymentLabel}
										checked={cash}
										onChange={changeSwitch}
									/>
									<DefaultSwitch
										label={strings?.bankPaymentLabel}
										checked={bank}
										onChange={changeSwitch}
									/>
								</div>
							</div>
						</div>
					</div>
					<div>
						<div>
							{mapInitialized && mapCenter !== null && (
								<MapContainer
									center={mapCenter}
									zoom={7.5}
									scrollWheelZoom={false}
									className={classes.mapContainerRegisterForm}
								>
									<TileLayer
										attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
										url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
									/>
									{position !== null && (
										<>
											<Marker
												draggable={true}
												position={position}
												icon={customIcon}
												eventHandlers={eventHandlers}
												ref={markerRef}
											>
												<Popup
													minWidth={90}
												>{`Position${position}`}</Popup>
											</Marker>
										</>
									)}
									<ResetCenterView
										selectedPosition={modalCountry}
										addressPosition={adressPosition}
									/>
								</MapContainer>
							)}
						</div>
						{(!latitude || !longitude) && (
							<p>{error || "Fetching location..."}</p>
						)}
					</div>
				</div>
				<Divider />
			</Modal>
		</>
	);
};

export default Client;
